<script lang="ts">
	import { storefront_prefix, img_prefix } from 'shared/var'
	import { get_related, type get_map } from 'shared/json_api/get_related'

	type Props = {
		item: ResourceTypes[`storefront_menu_item`]
		storefront_menu_items: ResourceTypes[`storefront_menu_item`][]
		included_map: ReturnType<typeof get_map>
		menu_href_prefix: string
		show_image: boolean
	}

	let { item, storefront_menu_items, included_map, menu_href_prefix, show_image }: Props = $props()

	let sub_items = $derived(storefront_menu_items.filter(sub_item => sub_item.relationships.parent_storefront_menu_item?.data?.id === item.id))
	let category = $derived(get_related(included_map, item, `storefront_product_category`))
	let name = $derived(item.attributes.name || category?.attributes.name)
	let href = $derived(sub_items.length
		? `${ menu_href_prefix }${ item.id }`
		: category
			? `${ storefront_prefix }/product-category/${ category.attributes.slug }`
			: item.attributes.href)
</script>

<a href={href} class="card" class:show_image class:emphasize={item.attributes.emphasis_color_hex} style={`color: #${ item.attributes.emphasis_color_hex }; --background-image: url('${ img_prefix }/${ item.attributes.image_url }?w=1000&h=500&fit=crop&auto=format,compress');`}>
	<div class="contents">
		{name}

		{#if sub_items.length}
			<svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="10 0 2 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter"><path d="M8 6l6 6-6 6"/></svg>
		{/if}
	</div>
</a>

<style>
	a.card {
		text-decoration: none;
		overflow: hidden;
		color: white;
		background-position: center;
		background-size: cover;
		min-height: 30px;
		align-items: center;
		display: flex;
	}

	a.card.show_image {
		background-image: var(--background-image);
		position: relative;
	}

	a.card.show_image::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: linear-gradient(10deg,
			rgba(0, 0, 0, 1) 0%,
			rgba(0, 0, 0, 1) 10%,
			rgba(0, 0, 0, 0) 50%,
			rgba(0, 0, 0, 0) 100%
		);
		z-index: 0;
	}

	.contents {
		font-size: 20px;
		font-family: 'Protipo Narrow', sans-serif;
		text-transform: uppercase;
		letter-spacing: 1px;
		align-items: center;
		padding: 0 15px;
		font-weight: 500;
		line-height: 1.2;
		z-index: 1;
		display: flex;
		gap: 10px;
		justify-content: space-between;
	}

	.show_image .contents {
		font-size: 30px;
		padding: 5%;
		align-items: end;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	@media(width <= 800px) {
		a.card {
			flex-basis: calc(50% - 10px);
		}
		a.card.show_image {
			padding-bottom: 25%;
		}
		.show_image .contents {
			font-size: 3vw;
		}
	}

	@media(width <= 500px) {
		a.card {
			flex-basis: 100%;
		}
		a.card.show_image {
			padding-bottom: 50%;
		}
		.show_image .contents {
			font-size: 6vw;
		}
	}

	.card.emphasize {
		border-left: 5px solid;
	}

	svg {
		text-align: right;
	}
</style>
